// extracted by mini-css-extract-plugin
export var headerNoLevel = "styles-module--headerNoLevel--ac507";
export var heading = "styles-module--heading--4de32";
export var left = "styles-module--left--b4ed9";
export var wrapper = "styles-module--wrapper--bcc0e";